{
  "about": {
    "title": "Über Spring Boot Admin",
    "label": "Über"
  }
}
